// German Content for ME-SupportNet Website

export const APP_INFO_DE = {
  name: 'ME SupportNet',
  tagline: 'Menschen mit ME unterstützen und vernetzen',
  description: 'ME SupportNet ist eine App für Menschen mit ME, Long-/Post-Covid, PostVac und verwandten Erkrankungen. Sie unterstützt und verbindet Menschen mit ME in ihrer unmittelbaren Umgebung – niedrigschwellig, ortsbasiert und intuitiv.',
};

export const HOME_CONTENT_DE = {
  hero: {
    title: 'ME SupportNet',
    subtitle: 'Menschen mit ME unterstützen und vernetzen',
    tagline: '',
    description: 'ME SupportNet ist eine App für Menschen mit ME, Long-/Post-Covid, PostVac und verwandten Erkrankungen.',
    buttons: {
      learnMore: 'Mehr erfahren',
      whatIsME: 'Was ist ME?',
      joinUs: 'Mitmachen',
    },
  },
  introduction: {
    title: 'ME SupportNet',
    subtitle: 'Hilfe und Vernetzung für Betroffene',
    paragraphs: [
      'ME SupportNet ist eine App für Menschen mit ME/CFS (ME), Long-/Post-Covid, PostVac und verwandten Erkrankungen. Sie erleichtert den Kontakt von Betroffenen untereinander sowie mit Unterstützenden in ihrer unmittelbaren Umgebung – niedrigschwellig, ortsbasiert und intuitiv.'
    ],
  },
  availabilityNotice: {
    title: 'Bald verfügbar',
    text: 'Diese App befindet sich derzeit in Entwicklung und wird hier bald verfügbar sein!',
    platformsLabel: 'Für Android & iOS',
  },
  pillars: {
    title: 'Die vier Säulen',
    subtitle: 'Was ME SupportNet bietet',
    items: [
      {
        id: 'help',
        title: 'Hilfe',
        icon: 'Favorite',
        description: 'Wir vermitteln Kontakte zwischen Betroffenen und lokalen Alltagshelfer*innen, z.B. für Einkäufe oder als Begleitung zu Terminen.',
      },
      {
        id: 'connect',
        title: 'Vernetzen',
        icon: 'People',
        description: 'Wir vernetzen Betroffenen miteinander zur gegenseitigen Unterstützung, online und lokal.',
      },
      {
        id: 'events',
        title: 'Events',
        icon: 'Event',
        description: 'Wir informieren über Veranstaltungen von und für Menschen mit ME – auch über Deine.',
      },
      {
        id: 'resources',
        title: 'Ressourcen',
        icon: 'MenuBook',
        description: 'Ressourcen-Zentrum mit Informationen zu Therapieansätzen, Medikamenten sowie Links zu externen Quellen.',
      },
    ],
  },
  whyMatters: {
    title: 'Warum noch eine App?',
    subtitle: 'Um gesundheitliche Verschlechterungen zu vermeiden',
    description: 'In Deutschland gibt es über 650.000 ME-Betroffene. Bei ME können bereits geringe Belastungen zu schweren und potenziell dauerhaften Zustandsverschlechterungen führen. Das Einhalten individueller Belastungsgrenzen (Pacing) ist derzeit der zentrale Schutzfaktor.',
    keyPoint: 'Daher will ME SupportNet Betroffene entlasten - durch Nachbarschaftshilfe, Vernetzung und Informationen zur Erkrankung.',
  },
  whatAppOffers: {
    title: 'Das bietet ME SupportNet',
    subtitle: 'Eine App für alle(s)',
    paragraphs: [
      {
        title: 'Hilfe',
        text: 'Kontakt mit lokalen Helfenden zur Unterstützung im Alltag. Bei ME SupportNet können Betroffene gezielt Hilfe bei alltäglichen Aufgaben finden, z.B. für Einkäufe, im Haushalt oder als Begleitung zu Arztterminen.',
      },
      {
        title: 'Vernetzung',
        text: 'Austausch und gegenseitige Unterstützung mit anderen Betroffenen. Durch die App entsteht ein lokales Netzwerk, das Isolation entgegenwirkt und den Erfahrungsaustausch zwischen Menschen mit ME fördert.',
      },
      {
        title: 'Events',
        text: 'Information zu Treffen und Veranstaltungen von und für Menschen mit ME, persönlich und online. User können auch selbst Veranstaltungen einstellen und so bekannter machen.',
      },
      {
        title: 'Ressourcen',
        text: 'Umfassendes Ressourcen-Zentrum mit Informationen zu Therapieansätzen, Medikamenten sowie vielen Links zu externen Quellen. Dies hilft Betroffenen, ihre Belastungsgrenzen besser zu verstehen und individuell relevante Informationen zu erhalten.',
      },
    ],
  },
  finalMessage: {
    title: 'ME SupportNet schafft lokale Vernetzung',
    subtitle: 'Gezielte Hilfe und Austausch – dort, wo sie gebraucht werden.',
  },
};

export const ABOUT_US_DE = {
  title: 'Über Uns',
  mission: {
    title: 'Unsere Mission',
    description: 'ME SupportNet hilft Menschen mit ME, Unterstützung im Alltag und lokale Kontakte zu finden. Wir wollen ein Netzwerk aus praktischer Hilfe und sozialen Kontakten aufbauen, das Isolation entgegenwirkt und gesundheitliche Verschlechterungen verhindert. Zusätzlich bietet ME SupportNet ein umfassendes Ressourcen-Zentrum, sowie eine übersichtliche Events Sektion mit einem übersichtlichen Veranstaltungskalender.',
  },
  vision: {
    title: 'Unsere Vision',
    description: 'Eine Welt, in der Menschen mit ME einfach Zugang zu lokalen Unterstützungsnetzwerken haben. Eine Gemeinschaft, in der praktischer Hilfe, gelebte Solidarität und eine bessere Lebensqualität für Betroffene Wirklichkeit sind.',
  },
  team: {
    title: 'Das Team',
    description: 'ME SupportNet wird von einem engagierten Team entwickelt, das den dringenden Bedarf an besseren Unterstützungssystemen versteht.',
    members: [
      {
        name: 'Erik Zürn',
        role: 'Dipl.-Biologe und PR-Berater',
        description: [
          'Seit 2022 Betroffener mit Post-Covid und in Folge ME. An schlechten Tagen ans dunkelstille Bett gefesselt, an guten Tagen sind ein paar Stunden Arbeit möglich. Als ehemaliger Wissenschaftskommunikator, jetzt in der vollen Erwerbsminderungsrente, nutzt Erik seine wenige Energie für die Gründung neuer Selbsthilfegruppen und die Beratung von Betroffenen - und jetzt auch die Entwicklung von ME SupportNet.',
        ],
      },
      {
        name: 'Birte Viermann',
        role: 'Dipl.-Psychologin, pflegende Angehörige',
        description: [
          'Früher Begleiterin ihrer 2022 an schwerster ME verstorbenen Schwester, heute aktiv in Richtung Aufklärung und Verbesserung der Lebensqualität Betroffener. Birte ist immer noch geschockt darüber, wie Menschen mit ME in unserer Gesellschaft leben müssen, und möchte mit ME SupportNet dazu beitragen, die Bedingungen zu verbessern.',
        ],
      },
      // Temporär ausgeblendet - Kommentarzeichen entfernen, um das Mitglied wieder anzuzeigen.
      // {
      //   name: 'Eine Entwicklerin mit ME',
      //   role: 'MSc. Software-Entwicklerin',
      //   description: [
      //     'Eine betroffene Entwicklerin, die seit einigen Jahren mit ME lebt und die täglichen Herausforderungen aus eigener Erfahrung kennt. Mit begrenzter Energie arbeitet sie in ihren verfügbaren Stunden am Aufbau von ME SupportNet, um ein Tool zu schaffen, das sie selbst gebraucht hätte.',
      //   ],
      // },
    ],
  },
  development: {
    title: 'Entwicklungsstand',
    description: 'Dank der Zusammenarbeit mit einer erfahrenen App-Entwicklerin schreitet ME SupportNet schneller voran als ursprünglich erwartet. Wir arbeiten auf eine Testphase hin und hoffen, die erste Version bald zu starten.',
  },
};

export const WHAT_IS_ME_DE = {
  title: 'Was ist ME?',
  description:
    "Myalgische Enzephalomyelitis (ME) ist eine komplexe, neuroimmunologische, chronische Erkrankung, die etwa 71 Millionen Menschen weltweit betrifft¹, allein in Deutschland 650.000+⁵, wobei viele Fälle undiagnostiziert bleiben.\n Diese Krankheit wird häufig durch Infektionen ausgelöst, aber auch bestimmte Antibiotika und körperliche Belastungen kommen als Auslöser in Frage. Die genauen Krankheitsmechanismen sind bislang unzureichend verstanden, eine Beteiligung verschiedene Funktionsstörungen des Nervensystems, des endokrinen Systems, des Immunsystems und anderer Systeme und Organe ist jedoch belegt.\n ME kann so schwer verlaufen, dass Betroffene grundlegende Fähigkeiten wie Essen oder Sprechen verlieren. Auch Licht- und Geräuschempfindlichkeit sind häufig; in schweren Fällen führt ME zur vollständigen Bettlägerigkeit.\n Obwohl ME Millionen Menschen weltweit betrifft und eine der schwersten chronischen Krankheiten ist, bleibt die Erkrankung stark missverstanden, die Forschung und Versorgung sind unterfinanziert und ME wird oft von Gesundheitsdienstleistern abgetan.",
  keyFacts: {
    title: 'Wichtige Fakten',
    description: 'Die grundlegenden Aspekte dieser komplexen Erkrankung verstehen',
    cards: [
      {
        icon: 'People',
        title: 'Globale Auswirkungen',
        description: 'Betrifft etwa 71 Millionen Menschen weltweit¹, wobei viele Fälle undiagnostiziert bleiben.',
      },
      {
        icon: 'Virus',
        title: 'Oft virale Auslöser',
        description: 'Wird oft durch Infektionen ausgelöst, einschließlich COVID-19, Epstein-Barr-Virus und andere Erreger.',
      },
      {
        icon: 'Health',
        title: 'Schwere Einschränkungen',
        description: 'Kann Betroffene vollständig ans Bett fesseln und einfachste Aktivitäten unmöglich machen.',
      },
    ],
  },
  pemDescription:
    'Post-exertionelle neuroimmune Erschöpfung (PENE) ist das Kardinalsymptom von ME.⁷ Es bedeutet eine Verschlechterung der Symptome nach selbst minimaler körperlicher/geistiger/emotionaler Anstrengung. PENE kann Tage, Wochen oder sogar permanent andauern und macht es Betroffenen unmöglich, normale Aktivitätsniveaus aufrechtzuerhalten.',
  whyThisMatters: {
    title: 'Warum Aufklärung über ME wichtig ist',
    description:
      'Aufklärung über ME ist von entscheidender Bedeutung, weil es Millionen von Menschen weltweit betrifft, und die Erkrankung immer noch weitgehend missverstanden und unterfinanziert ist. Für Betroffene bedeutet ME nicht nur eine massive gesundheitliche Einschränkung, sondern auch einen Mangel an gesellschaftlichem und medizinischem Verständnis. Trotz der Schwere der Krankheit wird ME häufig von Gesundheitsfachkräften nicht ernst genommen und bleibt unterfinanziert. Durch die Unterstützung von Forschung und Aufklärung können wir dazu beitragen, das Leben der Betroffenen zu verbessern und eine Zukunft mit besseren Behandlungsmöglichkeiten zu schaffen.',
  },
  symptoms: {
    title: 'Symptome',
    pemTitle: '⚠️ Post-exertionelle neuroimmune Erschöpfung (PENE) - Das Kardinalsymptom',
    otherSymptomsTitle: 'Weitere Symptome',
    list: [
      'Muskelschwäche',
      'Grippeähnliche Erschöpfung',
      'Nicht-erholsamer Schlaf',
      'Schmerzen in Muskeln, Gelenken oder Nerven',
      'Kognitive Funktionsstörungen (Gehirnnebel)',
      'Orthostatische Intoleranz (Schwierigkeiten beim Aufrichten, Stehen oder Sitzen)',
      'Überempfindlichkeit gegenüber Licht, Geräuschen und anderen Reizen',
    ],
  },
  economicImpact: {
    title: 'Wirtschaftliche Auswirkungen',
    description:
      'ME und Long COVID haben große wirtschaftliche Auswirkungen in Deutschland und kosten etwa 63 Milliarden Euro jährlich². Von dieser Gesamtsumme entfällt etwa die Hälfte auf ME. Dies umfasst Gesundheitskosten, Produktivitätsverluste und Kosten für Angehörige und Pflegekräfte. Ähnliche wirtschaftliche Auswirkungen wurden in anderen Ländern festgestellt, wo Studien vergleichbare Kosten relativ zum BIP zeigen.',
    source: 'https://mecfs-research.org/costreport-long-covid-and-mecfs/',
    study: {
      id: 'economicImpact',
      title: 'Wirtschaftliche Auswirkungen in Deutschland nach Jahr',
      tableHeaders: {
        year: 'Jahr',
        cost: 'Kosten',
        gdpImpactPercent: 'BIP-Anteil (%)',
      },
      data: [
        { year: '2022', cost: '58 Milliarden €', gdpImpact: 1.4 },
        { year: '2023', cost: '61 Milliarden €', gdpImpact: 1.5 },
        { year: '2024', cost: '63 Milliarden €', gdpImpact: 1.5 },
        { year: '2025 (geschätzt)', cost: '65 Milliarden €', gdpImpact: 1.6 },
      ],
      source: 'https://mecfs-research.org/costreport-long-covid-and-mecfs/',
      buttonText: 'Studie ansehen',
    },
  },
  mostDisabling: {
    title: 'ME - Eine der am stärksten einschränkenden chronischen Erkrankungen',
    description:
      'ME zählt zu den am stärksten einschränkenden chronischen Erkrankungen. Viele Betroffene erleben eine geringere Lebensqualität als Menschen mit Multipler Sklerose, Krebs oder Herzkrankheiten⁴. Mit ME zu leben bedeutet, ständig Schmerzen und andere Symptomen zu haben. Schwerbetroffene sind oft vollständig bettlägerig, unfähig, sich selbst zu versorgen, und erleben ihren Zustand als wären sie "lebendig begraben".',
    source: 'https://mecfs-research.org/researchfunding-munich/',
    study: {
      id: 'healthIndex',
      title: 'Gesundheitsindex-Vergleich',
      explanation:
        'Der EQ-5D 3L ist ein standardisiertes Maß, das körperliches, geistiges und soziales Wohlbefinden bewertet. Werte unter 0,5 zeigen eine erhebliche gesundheitliche Beeinträchtigung an, während Werte über 0,7 einen relativ guten Gesundheitszustand darstellen.',
      data: [
        { condition: 'ME', score: 0.47 },
        { condition: 'COPD', score: 0.65 },
        { condition: 'Multiple Sklerose', score: 0.67 },
        { condition: 'Rheumatoide Arthritis', score: 0.69 },
        { condition: 'Lungenkrebs', score: 0.69 },
        { condition: 'Schlaganfall', score: 0.71 },
        { condition: 'Diabetes Typ II', score: 0.72 },
        { condition: 'Darmkrebs', score: 0.74 },
        { condition: 'Gesamtbevölkerung', score: 0.85 },
      ],
      source: 'https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0132421',
      buttonText: 'Studie ansehen',
    },
  },
  prevalence: {
    title: 'ME - Eine häufige, aber unsichtbare Erkrankung',
    description:
      'Obwohl ME in der öffentlichen Wahrnehmung kaum präsent ist, ist die Erkrankung überraschend häufig. Sie betrifft schätzungsweise 71 Millionen Menschen weltweit¹, was etwa 0,9% der Weltbevölkerung entspricht. Dennoch erhält sie viel zu wenig Aufmerksamkeit und Finanzierung.',
    globalStats: {
      title: 'Globale Prävalenz',
      tableHeaders: {
        region: 'Region',
        cases: 'Fälle',
        populationPercent: 'Bevölkerung (%)',
      },
      data: [
        { region: 'Weltweit', cases: '~71 Millionen', percentage: '0,9%' },
        { region: 'USA', cases: '3-4 Millionen', percentage: '1-1,2%' },
        { region: 'Deutschland', cases: '~650.000', percentage: '0,8%' },
      ],
    },
    underdiagnosis: {
      title: 'Die versteckte Prävalenz',
      description:
        'Diese Zahlen repräsentieren wahrscheinlich nur einen Bruchteil der tatsächlichen Prävalenz, da ME notorisch unterdiagnostiziert ist. Bei vielen Betroffenen werden Depressionen, Angstzustände oder anderen Erkrankungen fehldiagnostiziert, während andere nie eine Diagnose erhalten. Die tatsächliche Anzahl der Betroffenen könnte deutlich höher sein.',
    },
    sourcesLabel: 'Quellen:',
    sources: [
      {
        name: 'Deutschland: Ärzteblatt-Artikel',
        url: 'https://www.aerzteblatt.de/news/medienbericht-long-covid-und-mecfs-kosten-gesellschaft-63-milliarden-euro-jahrlich-ac6ab36c-b2e4-40a1-8f27-6b52d53dd9e8',
      },
      {
        name: 'USA: NIH ME-Forschung',
        url: 'https://www.nih.gov/advancing-mecfs-research',
      },
      {
        name: 'Global: NIH ME-Studie',
        url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11907965/',
      },
    ],
  },
  longCovid: {
    title: 'Long COVID & ME',
    statement:
      'Studien deuten darauf hin, dass nach etwa einem halben Jahr Erkrankungsdauer circa die Hälfte der Long COVID-Betroffenen die Diagnosekriterien für ME erfüllt⁸.',
    description: 'ME ist die schwerste Form von Long COVID, aber COVID-19 ist nur einer von vielen Auslösern von ME.',
    keyPoints: [
      'ME ist die schwerste Form von Long COVID',
      'COVID-19 ist nur einer von vielen Auslösern',
      'Andere Auslöser sind das Epstein-Barr-Virus, Enteroviren, Herpes-Viren und bestimmte Antibiotika',
      'Der zugrundeliegende Krankheitsmechanismus ist höchstwahrscheinlich unabhängig vom Auslöser identisch',
      'ME wurde bereits Jahrzehnte vor COVID-19 dokumentiert',
    ],
  },
  livingWithME: {
    title: 'Was bedeutet es, mit ME zu leben?',
    description:
      'Mit ME zu leben bedeutet, nicht nur unter schweren gesundheitlichen Einschränkungen zu leiden, sondern auch einem Gesundheitssystem gegenüberzustehen, das die Krankheit oft nicht erkennt, versteht oder ernst nimmt. Viele Betroffene kämpfen darum, überhaupt medizinische Unterstützung zu erhalten. Qualifizierte Anlaufstellen sind rar, wirksame Behandlungen sind bisher kaum verfügbar oder befinden sich noch im experimentellen Stadium.',
    stages: [
      {
        severity: 'Milde',
        description:
          'Symptome schränken das tägliche Leben bereits erheblich ein; Betroffene haben nur einen Bruchteil ihres vorherigen Leistungsniveaus. Teilzeitarbeit ist möglich, oft aber nur durch Verzicht auf Freizeitaktivitäten und schwere Einschnitte im Sozialleben. Diese Einschränkungen sind für Außenstehende oft schwer zu verstehen.',
      },
      {
        severity: 'Moderate',
        description:
          'Betroffene sind aufgrund schwerer Symptome hausgebunden, arbeitsunfühig und auf Hilfe im Haushalt angewiesen. Sie können nur für begrenzte Zeit stehen und nur kurze Strecken gehen. Mobilitätshilfen wie Rollstühle können die Lebensqualität verbessern, aber Versicherungen verweigern oft die finanzielle Unterstützung.',
      },
      {
        severity: 'Schwere',
        description:
          'Erkrankte sind meist bettlägerig und benötigen intensive Hilfe bei grundlegenden täglichen Aktivitäten und persönlicher Hygiene. Sie können sich nur für sehr kurze Zeit konzentrieren und sensorische Reize (Licht, Lärm, Berührung) nur kurz tolerieren. Viele haben kaum Zugang zu medizinischer Versorgung, da wenige Ärzt*innen Hausbesuche machen.',
      },
      {
        severity: 'Sehr schwere',
        description:
          'Eine der schwersten Erkrankungen überhaupt. Betroffene können keine sensorischen Reize (Licht, Lärm, Berührung) aushalten und müssen abgeschirmt in abgedunkelten, stillen Räumen liegen. Sie benötigen rund um die Uhr Pflege und manchmal künstliche Ernährung. Es gibt kaum ausreichend ausgebildetes Pflegepersonal.',
      },
    ],
  },
  impactOnPatients: {
    title: 'Auswirkungen auf Betroffene',
    description:
      'ME betrifft etwa 71 Millionen Menschen weltweit¹, wobei viele Fälle undiagnostiziert bleiben. Die Erkrankung kann schwere Einschränkungen verursachen; viele Betroffene sind bettlägerig oder hausgebunden.',
    additionalInfo:
      'Viele Betroffene stoßen im Gesundheitssystem auf Unglauben und kämpfen um eine angemessene medizinische Versorgung. Häufig werden sie fehldiagnostiziert. Der Mangel an Verständnis und Forschungsfinanzierung bedeutet, dass die meisten Behandlungen experimentell oder nicht verfügbar sind.',
    familyImpact:
      'Auch für Familien und Pflegekräfte stellt die Unterstützung von bettlägerigen und kontinuierlich pflegebedürftigen Erkrankten eine enorme Belastung dar, sowohl emotional als auch finanziell.',
  },
};

export const MITMACHEN_DE = {
  title: 'Mitmachen',
  subtitle: 'Sei dabei, wenn ME SupportNet startet',
  description: 'ME SupportNet befindet sich in der Entwicklung. Trag dich in die Warteliste ein und erfahre als Erste*r, wenn die App verfügbar ist. Wir melden uns bei dir, wenn es Neuigkeiten gibt.',
  waitlist: {
    title: 'Auf die Warteliste',
    nameLabel: 'Name',
    namePlaceholder: 'Dein Name',
    emailLabel: 'E-Mail-Adresse',
    emailPlaceholder: 'deine@email.de',
    roleLabel: 'Ich bin … (optional)',
    rolePlaceholder: 'Bitte wählen',
    roleOptions: [
      { value: 'affected', label: 'Betroffene*r' },
      { value: 'caregiver', label: 'Angehörige*r oder pflegende Person' },
      { value: 'supporter', label: 'Unterstützer*in / Ehrenamtliche*r' },
      { value: 'other', label: 'Andere' },
    ],
    howHeardLabel: 'Wie hast du von uns erfahren? (optional)',
    howHeardPlaceholder: 'z. B. Instagram, Selbsthilfegruppe, Empfehlung …',
    deviceLabel: 'Gerät (optional)',
    devicePlaceholder: 'Bitte wählen',
    deviceOptions: [
      { value: 'apple', label: 'Apple (iPhone / iPad)' },
      { value: 'android', label: 'Android' },
    ],
    offersResourcesIntro: 'Falls du weitere Kontakte, Informationen oder Ähnliches hast, trag das gerne ein – wir freuen uns!',
    offersResourcesPlaceholder: 'z. B. Kontakt zu Multiplikatoren etc. (optional)',
    privacyLabel: 'Ich willige ein, dass die von mir angegebenen Daten für die Warteliste verarbeitet werden. Wähle ich als Rolle „Betroffene*r" aus, willige ich ausdrücklich auch in die Verarbeitung dieser Gesundheitsangabe ein (Art. 9 Abs. 2 lit. a DSGVO).',
    privacyNote: 'Deine Daten (Name und E-Mail-Adresse) werden für die Benachrichtigung über den App-Start genutzt. Wenn du Ressourcen oder Kontakte angibst, dürfen wir dich auch dazu kontaktieren. Wir verkaufen deine Daten nicht und geben sie nicht zu Werbezwecken weiter. Die Speicherung erfolgt bei unseren Auftragsverarbeitern Netlify Inc. und Airtable Inc. (beide USA, EU-Standardvertragsklauseln); Einzelheiten dazu findest du in Abschnitt 4 der Datenschutzerklärung. Du kannst deine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen: ',
    privacyContact: 'kontakt(at)me-support.net',
    submitButton: 'Eintragen',
    successTitle: 'Du bist dabei!',
    successMessage: 'Vielen Dank! Wir benachrichtigen dich, sobald ME SupportNet startet. Bis dahin – danke für deine Unterstützung.',
    errorMessage: 'Leider ist etwas schiefgelaufen. Bitte versuche es später noch einmal oder schreib uns direkt an kontakt(at)me-support.net.',
    requiredHint: '* Pflichtfelder',
  },
  contact: {
    title: 'Noch Fragen?',
    description: 'Hast du weitere Fragen oder möchtest du anderweitig unterstützen? Wir freuen uns über jede Nachricht.',
    email: 'kontakt(at)me-support.net',
  },
  moreWays: {
    title: 'Weitere Möglichkeiten zum Mitmachen',
    items: [
      {
        title: 'ME SupportNet bekannt machen',
        description: 'Teile Infos über ME SupportNet in deinem Netzwerk. Je mehr Menschen die App kennen, desto stärker wird unsere Community.',
        action: 'Auf Instagram folgen',
      },
      {
        title: 'Finanziell unterstützen',
        description: 'Finanzielle Unterstützung hilft uns, die App schneller zu entwickeln und sicherzustellen, dass sie für alle Nutzer*innen kostenlos bleibt.',
        action: 'Spenden',
      },
    ],
  },
};

export const SOCIAL_MEDIA_DE = {
  instagram: {
    handle: '@mesupportnet',
    url: 'https://www.instagram.com/mesupportnet/',
    description: 'Folgen Sie uns auf Instagram für Updates zur Entwicklung von ME SupportNet, zur Aufklärung über ME und zu Ereignissen in der Community.',
  },
  page: {
    title: 'Folgen Sie unserer Entwicklung',
    subtitle: 'Bleiben Sie auf dem Laufenden darüber, wie es mit ME SupportNet weitergeht',
    callToAction: {
      title: 'In Kontakt bleiben',
      description: 'Folgen Sie uns auf Instagram für Updates zur Entwicklung von ME SupportNet, zur Aufklärung über ME und zu Ereignissen in der Community.',
      button: 'Folgen Sie @mesupportnet',
    },
  },
};

export const DONATION_INFO_DE = {
  title: 'ME SupportNet unterstützen',
  subtitle: 'Ihre Spende hilft uns, ME SupportNet zu denen zu bringen, die es am meisten brauchen',
  description: 'Unsere Kosten umfassen die Entwicklung der App, Rechtsberatung, Server-Infrastruktur und die laufende Wartung. Ihre Unterstützung macht dies möglich.',
  mainDonationButton: {
    title: 'Jetzt spenden',
    description: '',
    url: 'https://www.we-aid.org/de/project-details/104/',
  },
  impactSection: {
    title: 'Hier wirkt Ihre Spende',
    cards: [
      {
        title: 'Entwicklung der App',
        description: 'Aufbau und Testen der ME SupportNet-App, so dass sie die Bedürfnisse von Menschen mit ME erfüllt.',
      },
      {
        title: 'Rechtsberatung',
        description: 'Sicherstellen, dass Datenschutzstandards erfüllt werden und die App einen sicheren Raum für vulnerable Nutzer*innen bietet.',
      },
      {
        title: 'Aufklärung',
        description: 'Unterstützung von Aufklärungsbemühungen und Forschungsinitiativen zu ME.',
      },
    ],
  },
};

// Legal content - German version
export const LEGAL_CONTENT_DE = {
  impressum: {
    title: 'Impressum',
    contact: {
      title: 'Angaben gemäß § 5 DDG',
      initiative: 'ME SupportNet ist eine Initiative der WE AID gGmbH.',
      description: 'Diese Website wird betrieben von:',
      responsible: 'Verantwortlich für den Inhalt:',
      contact: 'Kontakt:',
      name: 'WE AID gGmbH',
      address: 'Anna-Louisa-Karsch-Str. 2',
      city: '10178 Berlin',
      country: 'Deutschland',
      email: 'E-Mail: kontakt(at)me-support.net',
      management: 'Vertreten durch die Geschäftsführung: Christian Berger, Jan Strecker',
      registerTitle: 'Registereintrag:',
      registerInfo: 'Eintragung im Handelsregister',
      registerCourt: 'Registergericht: Amtsgericht Berlin Charlottenburg',
      registerNumber: 'Registernummer: HRB 241239 B',
      ustIdTitle: 'Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG:',
      ustId: 'DE35 2372345',
    },
    purpose: {
      title: 'Zweck der Website',
      description: 'Diese Website informiert über ME SupportNet — eine App-Initiative für Menschen mit Myalgischer Enzephalomyelitis/Chronischem Fatiguesyndrom (ME/CFS). ME SupportNet ist ein Projekt der WE AID gGmbH, einer gemeinnützigen Gesellschaft mit beschränkter Haftung.',
      goal: 'Das Ziel ist die Information über ME SupportNet und die Aufklärung über Myalgische Enzephalomyelitis/Chronisches Fatiguesyndrom (ME).',
    },
    disclaimer: {
      title: 'Haftungsausschluss',
      content: {
        title: 'Inhaltliche Verantwortung:',
        text: 'Die bereitgestellten Informationen dienen ausschließlich Bildungs- und Informationszwecken. Es wird keine Garantie für die Richtigkeit medizinischer Informationen gegeben. Für medizinische Fragen wenden Sie sich bitte an qualifizierte Ärzte.',
      },
      external: {
        title: 'Externe Links:',
        text: 'Diese Website enthält Links zu externen Websites. Die jeweiligen Anbieter sind für den Inhalt dieser externen Websites verantwortlich. Wir haben keinen Einfluss auf deren Inhalt und übernehmen keine Haftung dafür.',
      },
      donations: {
        title: 'Spenden:',
        text: 'Alle Spenden werden direkt zur Unterstützung der App-Entwicklung und ME-Aufklärung weitergeleitet. Wir gewährleisten eine transparente Verwendung der Mittel.',
      },
    },
    copyright: {
      title: 'Urheberrecht',
      description: 'Der Inhalt dieser Website ist urheberrechtlich geschützt. Die Nutzung von Texten, Bildern oder anderem Inhalt ist nur mit ausdrücklicher Zustimmung gestattet.',
      images: 'Bildquellen: Alle verwendeten Bilder stammen aus lizenzfreien Quellen oder wurden mit entsprechenden Rechten verwendet.',
    },
    additional: {
      title: 'Weitere rechtliche Informationen',
      links: 'Datenschutzerklärung | Cookie-Erklärung',
    },
  },
  privacy: {
    title: 'Datenschutzerklärung',
    websiteIntro: {
      title: 'I. Diese Website — Datenverarbeitung',
      description: 'Die Abschnitte 1 bis 8 gelten für die Website me-support.net. Die Datenverarbeitung in der ME SupportNet App ist im zweiten Teil dieser Erklärung beschrieben.',
    },
    responsible: {
      title: '1. Verantwortlicher für die Datenverarbeitung',
      description: 'Verantwortlich für die Datenverarbeitung auf dieser Website und in der ME SupportNet App:',
      initiative: 'ME SupportNet ist eine Initiative der WE AID gGmbH.',
      name: 'WE AID gGmbH',
      address: 'Anna-Louisa-Karsch-Str. 2',
      city: '10178 Berlin',
      country: 'Deutschland',
      email: 'E-Mail: kontakt(at)me-support.net',
    },
    general: {
      title: '2. Allgemeine Hinweise zur Datenverarbeitung',
      description: 'Diese Datenschutzerklärung gilt für (a) diese Website und (b) die ME SupportNet Mobile App (iOS/Android). ME SupportNet ist ein Projekt der WE AID gGmbH.',
      principle: 'Grundsatz: Wir erheben und verarbeiten nur die Daten, die für den jeweiligen Zweck notwendig sind. Gesundheitsdaten werden ausschließlich auf Grundlage Ihrer ausdrücklichen Einwilligung verarbeitet.',
    },
    automatic: {
      title: '3. Automatisch erfasste Daten',
      server: {
        title: 'Server-Logfiles:',
        description: 'Bei jedem Zugriff auf unsere Website werden automatisch folgende Daten durch unseren Hosting-Anbieter Netlify Inc. (512 2nd Street, San Francisco, CA 94107, USA) erfasst:',
        data: [
          'IP-Adresse des zugreifenden Rechners',
          'Datum und Uhrzeit des Zugriffs',
          'Name und URL der abgerufenen Datei',
          'Übertragene Datenmenge',
          'Meldung über erfolgreichen Abruf',
          'Browsertyp und -version',
          'Betriebssystem des Nutzers',
        ],
      },
      legal: 'Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der technischen Funktionsfähigkeit und Sicherheit der Website)',
      retention: 'Speicherdauer: Diese Daten werden automatisch nach 7 Tagen gelöscht.',
      transfer: 'Drittlandübermittlung: Netlify Inc. hat seinen Sitz in den USA. Die Übermittlung stützt sich auf die Standardvertragsklauseln der EU-Kommission (Art. 46 Abs. 2 lit. c DSGVO). Netlify ist für uns als Auftragsverarbeiter nach Art. 28 DSGVO tätig.',
    },
    waitlist: {
      title: '4. Wartelisten-Anmeldung („Mitmachen")',
      description: 'Auf der Seite „Mitmachen" können Sie sich freiwillig in die Warteliste für den Start der ME SupportNet App eintragen. Dabei verarbeiten wir ausschließlich die Angaben, die Sie selbst in das Formular eingeben:',
      data: [
        'Name (Pflichtangabe)',
        'E-Mail-Adresse (Pflichtangabe)',
        'Rolle: Betroffene*r, Angehörige*r oder pflegende Person, Unterstützer*in oder Andere (freiwillig)',
        'Gerät: Apple oder Android (freiwillig)',
        'Angabe, wie Sie von uns erfahren haben (freiwillig)',
        'Freitextangaben zu Ressourcen oder Kontakten, die Sie uns anbieten möchten (freiwillig)',
        'Ihre Einwilligung sowie Datum und Uhrzeit der Anmeldung (Nachweis gemäß Art. 7 Abs. 1 DSGVO)',
      ],
      purpose: {
        title: 'Zweck der Verarbeitung:',
        description: 'Wir verwenden diese Angaben ausschließlich, um Sie über den Start der App und über wesentliche Neuigkeiten zum Projekt zu informieren. Wenn Sie im Freitextfeld Ressourcen oder Kontakte nennen, sprechen wir Sie auch dazu an. Die Angaben zu Rolle und Gerät helfen uns bei der Planung der Veröffentlichung. Eine Weitergabe zu Werbezwecken oder ein Verkauf Ihrer Daten findet nicht statt.',
      },
      sensitive: {
        title: 'Hinweis zu Gesundheitsangaben:',
        description: 'Wenn Sie als Rolle „Betroffene*r" auswählen, liegt darin eine Angabe über Ihre Gesundheit im Sinne von Art. 9 DSGVO. Diese Angabe ist freiwillig und wird ausschließlich auf Grundlage Ihrer ausdrücklichen Einwilligung verarbeitet (Art. 9 Abs. 2 lit. a DSGVO). Sie können das Formular auch ohne diese Angabe absenden.',
      },
      processors: {
        title: 'Empfänger und Auftragsverarbeiter:',
        description: 'Ihre Formulardaten werden über eine Serverfunktion unseres Hosting-Anbieters Netlify Inc. (512 2nd Street, San Francisco, CA 94107, USA) an Airtable übermittelt und dort in einer Datenbank gespeichert. Anbieterin ist Airtable Inc., 799 Market Street, San Francisco, CA 94103, USA. Beide Unternehmen sind für uns als Auftragsverarbeiter nach Art. 28 DSGVO tätig und dürfen die Daten ausschließlich nach unseren Weisungen verarbeiten. Da beide ihren Sitz in den USA haben, werden die Daten in ein Drittland übermittelt; die Übermittlung stützt sich auf die Standardvertragsklauseln der EU-Kommission (Art. 46 Abs. 2 lit. c DSGVO). Trotz dieser Garantien lässt sich ein Zugriff US-amerikanischer Behörden auf die Daten nicht vollständig ausschließen.',
      },
      legal: 'Rechtsgrundlage: Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO; bei Auswahl von „Betroffene*r" zusätzlich Art. 9 Abs. 2 lit. a DSGVO). Ohne Einwilligung ist eine Anmeldung zur Warteliste nicht möglich; alle übrigen Funktionen der Website können Sie unabhängig davon nutzen.',
      retention: 'Speicherdauer: Wir speichern Ihre Angaben, bis der Zweck entfällt — also bis zum Start der App und der Benachrichtigung darüber —, längstens jedoch 24 Monate nach Ihrer Anmeldung. Danach werden sie gelöscht. Widerrufen Sie Ihre Einwilligung vorher, löschen wir Ihre Angaben unverzüglich.',
      withdrawal: 'Widerruf: Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen — formlos per E-Mail an kontakt(at)me-support.net. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt unberührt.',
    },
    cookies: {
      title: '5. Cookies und lokale Speicherung',
      necessary: {
        title: 'Präferenz-Cookies und lokale Speicherung:',
        description: 'Diese Website speichert auf Wunsch Ihre Spracheinstellung, Ihre Design-Auswahl (hell/dunkel) sowie Ihre Cookie-Entscheidung. Technisch geschieht das teils über einen Cookie (Design-Modus), teils über den lokalen Speicher Ihres Browsers (Sprache, Cookie-Entscheidung). Gespeichert wird ausschließlich nach Ihrer ausdrücklichen Einwilligung: Solange Sie nicht zugestimmt haben, legen wir nichts auf Ihrem Gerät ab. Wenn Sie ablehnen oder eine Einwilligung zurückziehen, werden bereits vorhandene Einträge gelöscht.',
      },
      analytics: {
        title: 'Analyse-Cookies (Google Analytics 4):',
        description: 'Nur wenn Sie im Cookie-Banner oder in den Cookie-Einstellungen ausdrücklich zustimmen, setzen wir Google Analytics 4 ein, um die Nutzung der Website statistisch auszuwerten (z. B. welche Seiten aufgerufen werden). Anbieter ist Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Dabei werden Cookies gesetzt (u. a. _ga) und eine gekürzte IP-Adresse sowie ein pseudonymes Nutzungsprofil dieser Website verarbeitet. Eine Übermittlung an Google LLC in den USA ist nicht ausgeschlossen; sie stützt sich auf Standardvertragsklauseln (Art. 46 DSGVO) sowie die Zertifizierung von Google LLC unter dem EU-U.S. Data Privacy Framework. Sie können Ihre Einwilligung jederzeit über die Cookie-Einstellungen mit Wirkung für die Zukunft widerrufen; die gesetzten Analyse-Cookies werden dann gelöscht.',
      },
      tracking: {
        title: 'Keine Marketing-Cookies:',
        description: 'Wir setzen keine Werbe- oder Marketing-Cookies ein und geben keine Daten zu Werbezwecken weiter. Die geräteübergreifenden Werbefunktionen von Google (Google Signals, Werbepersonalisierung) sind deaktiviert.',
      },
      legal: 'Rechtsgrundlage: Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO, § 25 Abs. 1 TDDDG). Ohne Ihre Einwilligung werden keine Cookies gesetzt und keine Daten in Ihrem Browser gespeichert. Der Widerruf ist jederzeit über die Cookie-Einstellungen möglich und berührt nicht die Rechtmäßigkeit der bis dahin erfolgten Verarbeitung.',
    },
    external: {
      title: '6. Externe Links und Dienste',
      donations: {
        title: 'Spenden-Links:',
        description: 'Diese Website enthält Links zu externen Spendenplattformen. Diese externen Anbieter sind für die Verarbeitung Ihrer Daten auf ihren Websites verantwortlich. Bitte beachten Sie deren jeweilige Datenschutzerklärungen.',
      },
      social: {
        title: 'Soziale Medien:',
        description: 'Links zu sozialen Medien führen zu externen Plattformen. Die Datenschutzbestimmungen dieser Plattformen gelten für die Nutzung ihrer Dienste.',
      },
    },
    rights: {
      title: '7. Ihre Rechte als betroffene Person',
      description: 'Sie haben folgende Rechte nach der DSGVO:',
      list: [
        'Auskunftsrecht (Art. 15 DSGVO)',
        'Recht auf Berichtigung (Art. 16 DSGVO)',
        'Recht auf Löschung (Art. 17 DSGVO)',
        'Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)',
        'Recht auf Datenübertragbarkeit (Art. 20 DSGVO)',
        'Widerspruchsrecht (Art. 21 DSGVO)',
      ],
      contact: 'Kontakt: Für die Ausübung Ihrer Rechte kontaktieren Sie uns bitte unter der oben genannten E-Mail-Adresse.',
    },
    changes: {
      title: '8. Änderungen dieser Datenschutzerklärung',
      description: 'Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte Rechtslagen oder bei Änderungen unserer Website oder App anzupassen. Die jeweils aktuelle Version ist auf dieser Website verfügbar.',
    },
    appIntro: {
      title: 'II. ME SupportNet App — Datenverarbeitung',
      version: 'Version 1.7 · Stand Juli 2026',
      description: 'Die folgenden Abschnitte entsprechen wortgleich der Datenschutzerklärung, die in der ME SupportNet Mobile App (iOS und Android) angezeigt und dort bei der Registrierung akzeptiert wird.',
      summaryLabel: 'Kurzfassung:',
      summary: 'ME SupportNet verarbeitet besonders sensible Daten, weil die App Menschen mit ME/CFS, Long-/Post-Covid, PostVac und verwandten Erkrankungen unterstützt. Du entscheidest, welche Angaben du machst und wer sie sehen darf. Gesundheits- und Standortdaten verwenden wir nur für die von dir gewählten App-Funktionen. Du kannst Einwilligungen jederzeit widerrufen und dein Konto löschen.',
    },
    appSections: [
      {
        heading: '1. Verantwortlicher',
        body: 'ME SupportNet ist eine Initiative der WE AID gGmbH\nAnna-Louisa-Karsch-Str. 2, 10178 Berlin\n(vertreten durch die Geschäftsführung: Christian Berger, Jan Strecker)\n\nBei Fragen zum Datenschutz: support@me-support.net',
      },
      {
        heading: '2. Datenschutzbeauftragter (DSB)',
        body: 'Interner Datenschutzbeauftragter gemäß Art. 13 Abs. 1 lit. b DSGVO:\n\nChristian Berger\nWE AID gGmbH\nAnna-Louisa-Karsch-Str. 2, 10178 Berlin\n\nDu kannst den DSB direkt kontaktieren: christian@me-support.net',
      },
      {
        heading: '3. Welche Daten wir verarbeiten',
        body: 'Wir verarbeiten folgende Kategorien personenbezogener Daten:\n\n• Kontodaten: E-Mail-Adresse, Name, Land, Sprache – für Registrierung und Anmeldung.\n• Profildaten: Nutzername, Biografie, Interessen, Stadt, PLZ, Alter, Pronomen – zur Personalisierung und für Community-Funktionen.\n• Profilbild (Avatar): Gespeichert auf Backblaze B2 (EU Amsterdam). Die Bild-URL ist ohne Anmeldung abrufbar – lade nur Bilder hoch, die du öffentlich teilen möchtest.\n• Gesundheitsbezogene Daten (Sonderkategorie Art. 9 DSGVO): Nutzertyp (Betroffene*r / Unterstützer*in), Schweregrad der Erkrankung, eingetragene Behandlungsansätze (z. B. Medikamente, Nahrungsergänzungsmittel, Therapien) – nur bei freiwilliger Angabe.\n• Community-Inhalte: Veranstaltungen, Hilfeanfragen/-angebote, Freundschaftsanfragen.\n• Nachrichten: Ende-zu-Ende-verschlüsselt (AES-256-GCM). Wir können den Inhalt nicht lesen.\n• Push-Benachrichtigungen: Geräte-Token (pseudonym) – zur Übermittlung von App-Benachrichtigungen (neue Nachrichten, Event-Änderungen, News-Artikel, Freundschaftsanfragen) über APNs (Apple) / FCM (Google). Jede Kategorie ist in den Einstellungen einzeln abschaltbar. Keine Gesundheitsdaten im Payload.\n• Technische Daten: IP-Adresse (bei Registrierung für Einwilligungsnachweis), Zeitstempel.',
      },
      {
        heading: '4. Rechtsgrundlagen',
        body: '• Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO): Für Kernfunktionen der App (Profil, Vernetzung, Community-Inhalte, Nachrichten).\n• Einwilligung (Art. 6 Abs. 1 lit. a DSGVO): Für optionale Funktionen wie Standort-Matching, Sichtbarkeit im Community-Feed und Push-Benachrichtigungen.\n• Ausdrückliche Einwilligung (Art. 9 Abs. 2 lit. a DSGVO): Für gesundheitsbezogene Angaben (Nutzertyp, Schweregrad, Behandlungsansätze).\n• Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO): Für Sicherheitslogs, Fehlerüberwachung (Sentry) und Missbrauchserkennung.\n• Nachweis der Einwilligung (Art. 7 DSGVO): Zeitpunkt und Version der akzeptierten Datenschutzerklärung werden gespeichert.\n\nOptionale Einwilligungen (Standort-Matching, Push-Benachrichtigungen) kannst du jederzeit einzeln im Datenschutz-Dashboard widerrufen. Die Einwilligung in die Verarbeitung deiner Gesundheitsdaten (Art. 9) ist Voraussetzung für die Nutzung der App; da die App auf dieser Verarbeitung beruht, kannst du sie nur widerrufen, indem du dein Konto löschst (Einstellungen → Konto löschen).',
      },
      {
        heading: '5. Datensicherheit',
        body: '• Nachrichten werden Ende-zu-Ende-verschlüsselt (E2EE). Private Schlüssel werden ausschließlich auf deinem Gerät gespeichert (iOS Keychain / Android Keystore); der Server speichert nur öffentliche Geräteschlüssel und verschlüsselte Schlüsselpakete, die er selbst nicht entschlüsseln kann.\n• Optional kannst du eine 12-Wörter-Wiederherstellungsphrase einrichten, um deinen Chatverlauf nach einem Gerätewechsel wiederherzustellen – auch diese Phrase kennt nur dein Gerät, wir können sie weder einsehen noch wiederherstellen.\n• Gesundheitsbezogene Felder (Schweregrad, Standortdaten, Biografie) sind feldverschlüsselt in der Datenbank gespeichert (AES-256-GCM).\n• Datenbankbackups werden vor der Übertragung verschlüsselt und erst dann in der Cloud gespeichert.\n• Übertragungen erfolgen ausschließlich per HTTPS/TLS.\n• Administrative Zugänge sind durch Zwei-Faktor-Authentifizierung (TOTP) und rollenbasierte Zugriffskontrollen gesichert; alle Zugriffe werden auditiert.\n• Passwörter werden gehasht gespeichert – wir sehen sie nie im Klartext.',
      },
      {
        heading: '6. Weitergabe an Dritte',
        body: 'Wir verkaufen deine Daten nicht. Dritte erhalten nur dann Zugriff, wenn dies für den Betrieb der App notwendig ist. Alle Auftragsverarbeiter sind vertraglich zur DSGVO-Konformität verpflichtet (Art. 28 DSGVO):\n\n• Supabase – Authentifizierung (EU, Frankfurt)\n• Railway – Backend-Hosting (EU, Frankfurt)\n• Backblaze B2 – verschlüsselte Backups + Profilbilder (EU, Amsterdam)\n• Apple APNs – iOS-Push-Benachrichtigungen (USA; SCCs gem. Art. 46 DSGVO)\n• Google FCM – Android-Push-Benachrichtigungen (USA; SCCs gem. Art. 46 DSGVO)\n• Resend – transaktionale E-Mails (Kontoverifizierung, Lösch-Vorwarnung, Moderations- und Widerspruchs-Benachrichtigungen); verarbeitet E-Mail-Adresse (USA; SCCs gem. Art. 46 DSGVO + EU-U.S. Data Privacy Framework)\n• Expo / EAS – App-Builds und Verteilung (kein Zugriff auf Nutzerdaten)\n• Sentry – Fehlerüberwachung, keine Gesundheitsdaten (EU)\n• PostHog – anonymisierte Nutzungsanalysen, keine Gesundheitsdaten (EU)',
      },
      {
        heading: '7. Speicherdauer',
        body: '• Profil- und Community-Daten: bis zur Kontolöschung.\n• Inaktive Konten: Wird ein Konto 12 Monate nicht mehr genutzt, senden wir eine Vorwarnung per E-Mail. 30 Tage danach wird das Konto mit allen personenbezogenen Daten automatisch gelöscht.\n• Zugriffslogs auf Gesundheitsdaten: 24 Monate (Art. 9 DSGVO).\n• Sicherheits-Audit-Logs: 12 Monate (Art. 32 DSGVO).\n• Einwilligungsnachweise: 3 Jahre nach Kontolöschung (Nachweispflicht Art. 7 DSGVO).\n\nNach Kontolöschung werden alle personenbezogenen Daten unwiderruflich gelöscht. Nachrichten werden aus Gründen der E2EE-Integrität anonym belassen.',
      },
      {
        heading: '8. Deine Rechte (Art. 15–22 DSGVO)',
        body: 'Du hast folgende Rechte:\n\n• Auskunft (Art. 15): Datenexport über Einstellungen → Profil → Meine Daten herunterladen.\n• Berichtigung (Art. 16): Profildaten jederzeit in der App bearbeitbar.\n• Löschung (Art. 17): Konto löschen über Einstellungen → Konto löschen.\n• Einschränkung der Verarbeitung (Art. 18).\n• Datenübertragbarkeit (Art. 20): Datenexport als JSON.\n• Widerspruch (Art. 21).\n\nAnfragen werden innerhalb von 1 Monat beantwortet (Art. 12 Abs. 3 DSGVO). Zur Ausübung deiner Rechte wende dich an: support@me-support.net',
        internalLink: { text: 'Konto und Daten löschen — alle Wege im Detail', to: '/account-deletion' },
      },
      {
        heading: '9. Keine automatisierte Entscheidungsfindung',
        body: 'Es findet keine ausschließlich automatisierte Verarbeitung statt, die rechtliche Wirkungen für dich erzeugt oder dich in ähnlicher Weise erheblich beeinträchtigt (Art. 22 DSGVO). Matching-Vorschläge basieren auf von dir eingegebenen Profildaten und werden nicht für automatisierte Entscheidungen genutzt.',
      },
      {
        heading: '10. Beschwerderecht',
        body: 'Du hast das Recht, dich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zuständig für WE AID gGmbH (Sitz Berlin) ist:\n\nBerliner Beauftragte für Datenschutz und Informationsfreiheit\nAlt-Moabit 59–61, 10555 Berlin\nE-Mail: mailbox@datenschutz-berlin.de',
        externalLink: { text: 'datenschutz-berlin.de', href: 'https://www.datenschutz-berlin.de' },
      },
    ],
  },
  cookies: {
    title: 'Cookie-Erklärung',
    what: {
      title: 'Was sind Cookies?',
      description: 'Cookies sind kleine Textdateien, die beim Besuch einer Website auf Ihrem Computer oder mobilen Gerät gespeichert werden. Sie helfen dabei, die Website zu verbessern und Ihnen eine bessere Nutzererfahrung zu bieten.',
    },
    which: {
      title: 'Welche Cookies verwendet diese Website?',
      necessary: {
        title: 'Technisch notwendige Cookies:',
        description: 'Diese Website funktioniert ohne technisch notwendige Cookies. Es werden keine Session-Cookies gesetzt, und ohne Ihre Einwilligung wird nichts auf Ihrem Gerät gespeichert.',
      },
      preferences: {
        title: 'Präferenz-Cookies und lokale Speicherung:',
        description: 'Wenn Sie zustimmen, merkt sich die Website Ihre Design-Auswahl (hell/dunkel) in einem Cookie namens „themeMode" (Laufzeit 1 Jahr) sowie Ihre Spracheinstellung und Ihre Cookie-Entscheidung im lokalen Speicher Ihres Browsers („language", „cookieConsent", „cookiePreferences", „cookieConsentData"). Sie können jede dieser Kategorien in den Cookie-Einstellungen einzeln an- und abwählen.',
      },
      analytics: {
        title: 'Analyse-Cookies (Google Analytics 4):',
        description: 'Nur mit Ihrer ausdrücklichen Einwilligung setzen wir Google Analytics 4 ein (Anbieter: Google Ireland Limited, Dublin), um die Nutzung der Website statistisch auszuwerten. Dabei werden Cookies wie „_ga" und „_ga_<ID>" gesetzt (Laufzeit bis zu 2 Jahre) und eine gekürzte IP-Adresse verarbeitet. Widerrufen Sie Ihre Einwilligung in den Cookie-Einstellungen, wird Google Analytics gestoppt und die zugehörigen Cookies werden gelöscht. Einzelheiten finden Sie in unserer Datenschutzerklärung.',
      },
      tracking: {
        title: 'Keine Marketing-Cookies:',
        description: 'Wir setzen keine Werbe- oder Marketing-Cookies ein und geben keine Daten zu Werbezwecken weiter. Die geräteübergreifenden Werbefunktionen von Google (Google Signals, Werbepersonalisierung) sind deaktiviert.',
      },
    },
    decline: {
      title: 'Was passiert, wenn Sie Cookies ablehnen?',
      description: 'Wenn Sie ablehnen, speichern wir nichts auf Ihrem Gerät — weder Cookies noch Einträge im lokalen Speicher Ihres Browsers. Bereits vorhandene Einträge aus früheren Besuchen werden dabei gelöscht. Das bedeutet:',
      effects: [
        'Ihre Spracheinstellung wird nicht gespeichert; die Website startet bei jedem Besuch auf Deutsch, sofern Sie keinen sprachspezifischen Link aufrufen',
        'Ihre Design-Auswahl (hell/dunkel) gilt nur für den aktuellen Besuch',
        'Google Analytics wird nicht geladen',
        'Das Cookie-Zustimmungsbanner wird bei Ihrem nächsten Besuch wieder angezeigt, weil wir Ihre Ablehnung nicht speichern dürfen, ohne etwas zu speichern',
        'Sie können alle Website-Funktionen normal nutzen',
      ],
    },
    manage: {
      title: 'Wie können Sie Cookies verwalten?',
      settings: {
        title: 'Cookie-Einstellungen dieser Website:',
        description: 'Über die Seite „Cookie-Einstellungen" können Sie Ihre Auswahl jederzeit ändern oder vollständig widerrufen. Die Änderung wirkt sofort: Abgewählte Kategorien werden umgehend von Ihrem Gerät entfernt.',
      },
      browser: {
        title: 'Browser-Einstellungen:',
        description: 'Sie können Cookies und lokale Speicherung zusätzlich in Ihren Browser-Einstellungen verwalten. Dort können Sie Cookies löschen oder die Cookie-Speicherung einschränken.',
      },
    },
    contact: {
      title: 'Kontakt',
      description: 'Wenn Sie Fragen zu Cookies oder Datenverarbeitung auf dieser Website haben, kontaktieren Sie uns gerne:',
      email: 'E-Mail: kontakt(at)me-support.net',
    },
  },
  terms: {
    title: "Allgemeine Geschäftsbedingungen",
    version: "Version 2.1 · Stand: Juni 2026",
    intro: "Diese Nutzungsbedingungen gelten für die ME SupportNet App und sind wortgleich mit der Fassung, die in der App angezeigt wird.",
    sections: [
      {
        heading: "§ 1 Anbieter, Geltungsbereich",
        body: "Diese Nutzungsbedingungen gelten für die Nutzung der App und der damit verbundenen Online-Angebote „ME SupportNet\".\n\nAnbieterin ist WE AID gGmbH, Anna-Louisa-Karsch-Str. 2, 10178 Berlin, Deutschland, E-Mail: support@me-support.net, vertreten durch die Geschäftsführung. Sollte ME SupportNet künftig durch einen anderen Rechtsträger betrieben werden, werden die Nutzerinnen und Nutzer vor Wirksamwerden eines Anbieterwechsels informiert.\n\nAbweichende Bedingungen der Nutzerinnen und Nutzer gelten nicht, es sei denn, die Anbieterin stimmt ihrer Geltung ausdrücklich zu.",
      },
      {
        heading: "§ 2 Zweck und Leistungsbeschreibung",
        body: "ME SupportNet ist eine technische Plattform zur niedrigschwelligen Vernetzung von Menschen mit ME/CFS, Long-/Post-Covid, PostVac und verwandten Erkrankungen mit unterstützenden Personen sowie zur Vernetzung Betroffener untereinander.\n\nDie Plattform ermöglicht insbesondere die Anlage eines Profils, die Suche nach Kontakten in der Nähe, Kommunikation über die App, Gruppen- oder Community-Funktionen, Hinweise zu sicherer Nutzung und Meldung problematischer Inhalte oder Kontakte.\n\nME SupportNet vermittelt keine medizinischen, pflegerischen, therapeutischen, psychotherapeutischen, transportbezogenen oder sonstigen professionellen Leistungen. Die Anbieterin wird nicht Partei von Absprachen, Hilfeleistungen, Treffen, Gefälligkeiten oder sonstigen Rechtsverhältnissen zwischen Nutzerinnen und Nutzern.",
      },
      {
        heading: "§ 3 Teilnahmevoraussetzungen und Nutzerkonto",
        body: "Die Nutzung ist nur natürlichen Personen ab 18 Jahren gestattet. Die Anbieterin kann einzelne Funktionen beschränken, wenn dies aus Gründen der Sicherheit, des Datenschutzes, der Missbrauchsvermeidung oder der technischen Stabilität erforderlich ist.\n\nBei der Registrierung sind die abgefragten Angaben wahrheitsgemäß zu machen. Ein Anspruch auf Registrierung oder dauerhafte Bereitstellung bestimmter Funktionen besteht nicht.\n\nNutzerinnen und Nutzer sind verpflichtet, Zugangsdaten geheim zu halten, ihr Konto gegen Zugriff Dritter zu schützen und die Anbieterin unverzüglich zu informieren, wenn Anhaltspunkte für einen Missbrauch bestehen.\n\nDie Nutzung unter Pseudonym ist zulässig, soweit einzelne Funktionen keine verifizierten Angaben erfordern. Ein Klarnamenszwang besteht nicht.",
      },
      {
        heading: "§ 4 Rollen in der Plattform",
        body: "Nutzerinnen und Nutzer können die Plattform insbesondere als betroffene Person, als unterstützende Person oder in beiden Rollen verwenden.\n\nBetroffene entscheiden selbst, welche Angaben sie zu Erkrankung, Unterstützungsbedarf, Belastungsgrenzen, Standort oder Kontaktwünschen machen und wem diese Angaben sichtbar werden.\n\nUnterstützende Personen entscheiden selbst, welche Art von Unterstützung sie anbieten. Sie sind nicht berechtigt, sich ohne entsprechende Qualifikation als medizinische, therapeutische, pflegerische oder sonstige Fachperson auszugeben.\n\nDie Anbieterin prüft Identität, Qualifikation, Zuverlässigkeit, Gesundheitszustand, Versicherungsschutz oder persönliche Eignung der Nutzerinnen und Nutzer nur, wenn eine bestimmte Prüfung ausdrücklich als solche bezeichnet wird. Allgemeine Profilangaben, Verifikationssymbole, Community-Bestätigungen oder Profilalter sind keine Garantie der Anbieterin.",
      },
      {
        heading: "§ 5 Keine medizinische Beratung, keine Notfallplattform",
        body: "ME SupportNet ersetzt keine ärztliche, psychotherapeutische, therapeutische, pflegerische oder sonstige fachliche Beratung, Diagnose oder Behandlung.\n\nInhalte in der App, einschließlich Erfahrungsberichte, Gruppenbeiträge, Chatnachrichten, Ressourcenhinweise oder Hinweise anderer Nutzerinnen und Nutzer, sind keine individuelle medizinische Empfehlung der Anbieterin.\n\nNutzerinnen und Nutzer dürfen Medikamente, Behandlungen, Dosierungen oder ärztlich vereinbarte Maßnahmen nicht allein aufgrund von Inhalten in ME SupportNet beginnen, ändern oder beenden. Gesundheitliche Entscheidungen sind mit qualifizierten Behandelnden zu besprechen.\n\n⚠️ ME SupportNet ist nicht für Notfälle bestimmt. Bei akuter Gefahr für Leben oder Gesundheit ist der örtliche Notruf, in Deutschland 112, zu kontaktieren. Bei dringenden medizinischen Fragen außerhalb akuter Notfälle kann in Deutschland der ärztliche Bereitschaftsdienst unter 116117 zuständig sein.",
      },
      {
        heading: "§ 6 Gesundheitsbezogene Inhalte und Off-Label-Erfahrungen",
        body: "Nutzerinnen und Nutzer dürfen eigene Erfahrungen zu Erkrankung, Alltag, Unterstützung, Symptomen, Pacing oder Behandlungen teilen, soweit sie dabei diese Nutzungsbedingungen, die Community-Regeln, Rechte Dritter und geltendes Recht beachten.\n\nErfahrungsberichte sind als persönliche Erfahrungen zu verstehen. Sie dürfen nicht als allgemein gültige Therapieempfehlung, Heilversprechen oder Aufforderung an andere formuliert werden.\n\nUntersagt sind insbesondere konkrete Dosierungsanweisungen, Aufforderungen zum Beginn, Absetzen oder Ändern von Medikamenten, Heilsversprechen, Verharmlosung erheblicher Risiken, medizinische Fernbehandlung durch hierzu nicht berechtigte Personen und die Veröffentlichung fremder Gesundheitsdaten ohne Einwilligung.\n\nBei Off-Label-Anwendungen dürfen Nutzerinnen und Nutzer nur sachlich und erfahrungsbezogen berichten. Off-Label-Anwendungen sind ärztlich abzuklären und können erhebliche Risiken haben.",
      },
      {
        heading: "§ 7 Standort, Kontaktaufnahme und reale Treffen",
        body: "Standortfunktionen dienen dazu, Kontakte in räumlicher Nähe zu erleichtern. Nutzerinnen und Nutzer entscheiden im Rahmen der App-Einstellungen, ob und in welchem Umfang Standortdaten genutzt oder angezeigt werden.\n\nDie Anbieterin empfiehlt, genaue Adressen, Telefonnummern und andere direkte Kontaktdaten erst nach sorgfältiger Prüfung und nur freiwillig weiterzugeben.\n\nTreffen, Besuche, Fahrten, Besorgungen, Begleitungen oder sonstige Unterstützungsleistungen erfolgen ausschließlich eigenverantwortlich zwischen den beteiligten Nutzerinnen und Nutzern. Die Anbieterin übernimmt keine Garantie für Identität, Verhalten, Verlässlichkeit, Qualifikation, Versicherungsschutz oder Sicherheit anderer Nutzerinnen und Nutzer.\n\nNutzerinnen und Nutzer sollen vor einem ersten Treffen die Sicherheits-Hinweise in der App beachten, insbesondere ein erstes Kennenlernen über die App, eine vorsichtige Freigabe persönlicher Daten, Treffen an sicheren Orten, Einbindung einer Vertrauensperson und Nutzung der Melde- und Blockierfunktionen.",
      },
      {
        heading: "§ 8 Pflichten der Nutzerinnen und Nutzer",
        body: "Nutzerinnen und Nutzer verpflichten sich, die Plattform respektvoll, rechtmäßig, datensparsam und rücksichtsvoll zu verwenden.\n\nUntersagt sind insbesondere Belästigung, Stalking, Diskriminierung, Drohungen, Gewaltaufrufe, Ausnutzen vulnerabler Personen, Betrug, Identitätstäuschung, kommerzielle Ansprache ohne Zustimmung der Anbieterin, Spam, Schadsoftware, automatisiertes Scraping, Umgehung technischer Schutzmaßnahmen und Veröffentlichung rechtswidriger Inhalte.\n\nNutzerinnen und Nutzer dürfen keine personenbezogenen Daten, Gesundheitsdaten, Screenshots, Chatverläufe, Fotos, Adressen oder sonstigen Informationen anderer Personen ohne deren Einwilligung veröffentlichen oder an Dritte weitergeben.\n\nNutzerinnen und Nutzer dürfen die Plattform nicht verwenden, um medizinische, therapeutische, pflegerische, finanzielle oder sonstige Leistungen anzubieten, für die eine behördliche Erlaubnis, fachliche Zulassung oder Versicherung erforderlich ist, sofern sie diese Voraussetzungen nicht erfüllen und nicht transparent nachweisen.",
      },
      {
        heading: "§ 9 Community-Regeln",
        body: "Die Community-Regeln sind Bestandteil dieser Nutzungsbedingungen. Sie konkretisieren insbesondere die Anforderungen an respektvollen Umgang, gesundheitsbezogene Inhalte, Datenschutz, reale Treffen, Meldungen und Sanktionen.\n\nDie Anbieterin kann in der App kurze Sicherheitshinweise, Warnhinweise und kontextbezogene Hinweise anzeigen. Diese Hinweise dienen dem Schutz der Nutzerinnen und Nutzer und sind zu beachten.",
      },
      {
        heading: "§ 10 Meldung rechtswidriger oder problematischer Inhalte und Beschwerdeverfahren",
        body: "Nutzerinnen und Nutzer können Inhalte, Profile, Nachrichten oder Verhaltensweisen melden, die rechtswidrig sind oder gegen diese Nutzungsbedingungen verstoßen. Meldende Personen erhalten eine elektronische Empfangsbestätigung mit einer eindeutigen Vorgangsnummer („Ticket-ID\") und werden über das Ergebnis der Prüfung informiert.\n\nMeldungen sollen möglichst konkret sein und den beanstandeten Inhalt, den Grund der Meldung und verfügbare Belege bezeichnen. Bei Ende-zu-Ende-verschlüsselten Chats kann es erforderlich sein, dass die meldende Person den beanstandeten Inhalt selbst bereitstellt, weil die Anbieterin private Nachrichten nicht anlasslos einsehen kann.\n\nDie Anbieterin prüft Meldungen sorgfältig und trifft eine angemessene Entscheidung. Mögliche Maßnahmen sind insbesondere Hinweis, Verwarnung, Entfernung oder Einschränkung von Inhalten, Sperrung einzelner Funktionen, vorübergehende oder dauerhafte Kontosperrung sowie Meldung an zuständige Stellen, soweit dies gesetzlich geboten oder zum Schutz erforderlich ist.\n\nBetroffene Nutzerinnen und Nutzer erhalten eine schriftliche Begründung der Maßnahme auf dauerhaftem Datenträger, soweit dies rechtlich zulässig ist und die Sicherheit anderer Personen, Ermittlungen oder Rechte Dritter nicht gefährdet.\n\n**Beschwerdeverfahren:** Innerhalb von sechs Monaten nach Bekanntgabe einer Moderationsmaßnahme können Betroffene unentgeltlich und elektronisch über die App-Funktion „Profil → Moderationsmaßnahmen → Beschwerde einlegen\" Widerspruch einlegen. Meldende Personen, deren Meldung eingestellt wurde, können unter „Profil → Meine Meldungen\" gegen die Einstellung Widerspruch einlegen. Beschwerden werden durch ein anderes Teammitglied als die Erstentscheidende Person geprüft (4-Augen-Prinzip) und in der Regel innerhalb von 14 Tagen entschieden. Daneben steht den Nutzerinnen und Nutzern der Weg zu außergerichtlichen Streitbeilegungsstellen nach Art. 21 DSA sowie der ordentliche Rechtsweg offen.",
      },
      {
        heading: "§ 11 Sperrung, Löschung und Kündigung",
        body: "Nutzerinnen und Nutzer können ihr Konto jederzeit über die App oder durch Mitteilung an die Anbieterin löschen lassen.\n\nDie Anbieterin kann ein Konto vorübergehend sperren oder kündigen, wenn konkrete Anhaltspunkte für einen Verstoß gegen diese Nutzungsbedingungen, Missbrauch, Sicherheitsrisiken oder rechtswidrige Nutzung bestehen. Die Maßnahme richtet sich nach Schwere, Wiederholungsgefahr und Schutzinteressen anderer Nutzerinnen und Nutzer.\n\nGesetzliche Rechte zur außerordentlichen Kündigung bleiben unberührt.\n\nNach Kontolöschung werden personenbezogene Daten nach Maßgabe der Datenschutzinformationen gelöscht oder anonymisiert, soweit keine gesetzlichen Aufbewahrungs- oder berechtigten Nachweisinteressen entgegenstehen.",
      },
      {
        heading: "§ 12 Verfügbarkeit und Änderungen der App",
        body: "Die Anbieterin bemüht sich um eine zuverlässige Bereitstellung der App. Eine jederzeitige, störungsfreie oder unveränderte Verfügbarkeit wird jedoch nicht zugesagt.\n\nDie Anbieterin kann Funktionen ändern, einschränken oder einstellen, wenn hierfür sachliche Gründe bestehen, insbesondere Sicherheit, Datenschutz, Missbrauchsvermeidung, technische Weiterentwicklung, rechtliche Anforderungen, wirtschaftliche Tragfähigkeit oder Schutz der Nutzerinnen und Nutzer.\n\nWesentliche Änderungen, die laufende Nutzungsmöglichkeiten erheblich beeinträchtigen, werden vorab angekündigt, soweit dies unter Berücksichtigung von Sicherheits- oder Rechtsgründen möglich ist.",
      },
      {
        heading: "§ 13 Datenschutz",
        body: "Die Verarbeitung personenbezogener Daten erfolgt nach Maßgabe der gesonderten Datenschutzinformationen von ME SupportNet.\n\nNutzerinnen und Nutzer entscheiden im Rahmen der App-Einstellungen, welche Profil- und Gesundheitsangaben sie machen und wem diese sichtbar werden. Für die Weitergabe von Informationen an andere Nutzerinnen und Nutzer sind die jeweiligen Nutzerinnen und Nutzer selbst verantwortlich.\n\nDie Anbieterin setzt technische und organisatorische Maßnahmen ein, um personenbezogene Daten zu schützen. Nutzerinnen und Nutzer bleiben verpflichtet, eigene Geräte, Zugangsdaten und freigegebene Informationen sorgfältig zu schützen.",
      },
      {
        heading: "§ 14 Rechte an Inhalten",
        body: "Nutzerinnen und Nutzer behalten die Rechte an den von ihnen eingestellten Inhalten.\n\nSie räumen der Anbieterin ein einfaches, räumlich unbeschränktes, unentgeltliches Recht ein, die Inhalte in dem Umfang zu speichern, technisch zu verarbeiten, darzustellen und anderen Nutzerinnen und Nutzern zugänglich zu machen, der für die Bereitstellung der gewählten App-Funktionen erforderlich ist.\n\nDie Rechteeinräumung endet grundsätzlich mit Löschung des Inhalts oder Kontos, soweit keine berechtigten Aufbewahrungs-, Nachweis- oder Sicherheitsinteressen entgegenstehen oder Inhalte in zulässiger anonymisierter Form fortbestehen.\n\nNutzerinnen und Nutzer dürfen nur Inhalte einstellen, zu deren Nutzung sie berechtigt sind und durch die keine Rechte Dritter verletzt werden.",
      },
      {
        heading: "§ 15 Haftung der Anbieterin",
        body: "Die Anbieterin haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit, bei Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit, bei Übernahme einer Garantie und in allen Fällen zwingender gesetzlicher Haftung.\n\nBei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten haftet die Anbieterin auf den vertragstypischen, vorhersehbaren Schaden. Wesentliche Vertragspflichten sind Pflichten, deren Erfüllung die ordnungsgemäße Nutzung der Plattform überhaupt erst ermöglicht und auf deren Einhaltung Nutzerinnen und Nutzer regelmäßig vertrauen dürfen.\n\nIm Übrigen ist die Haftung für leicht fahrlässige Pflichtverletzungen ausgeschlossen.\n\nDie Anbieterin haftet nicht für eigenverantwortliche Handlungen, Unterlassungen, Aussagen, Treffen, Hilfeleistungen oder sonstige Absprachen zwischen Nutzerinnen und Nutzern, soweit die Anbieterin hierfür nach gesetzlichen Vorschriften nicht verantwortlich ist.\n\nDie Anbieterin übernimmt keine Gewähr für Richtigkeit, Vollständigkeit, Aktualität oder medizinische Eignung von Inhalten anderer Nutzerinnen und Nutzer. Gesetzliche Rechte bleiben unberührt.",
      },
      {
        heading: "§ 16 Haftung der Nutzerinnen und Nutzer",
        body: "Nutzerinnen und Nutzer sind für eigene Inhalte, Angaben, Kontakte, Treffen und Absprachen selbst verantwortlich.\n\nNutzerinnen und Nutzer stellen die Anbieterin von Ansprüchen Dritter frei, die aus einer schuldhaften Verletzung dieser Nutzungsbedingungen oder Rechte Dritter durch die jeweiligen Nutzerinnen und Nutzer entstehen. Dies gilt nicht, soweit die Nutzerin oder der Nutzer die Verletzung nicht zu vertreten hat.",
      },
      {
        heading: "§ 17 Änderungen dieser Nutzungsbedingungen",
        body: "Die Anbieterin kann diese Nutzungsbedingungen ändern, wenn hierfür sachliche Gründe bestehen, insbesondere Änderungen der App, der Rechtslage, der Sicherheitsanforderungen oder der Plattformstruktur.\n\nWesentliche Änderungen werden den Nutzerinnen und Nutzern rechtzeitig mitgeteilt. Soweit gesetzlich erforderlich oder die Änderung nicht lediglich vorteilhaft oder neutral ist, wird die weitere Nutzung von einer ausdrücklichen Zustimmung abhängig gemacht.\n\nLehnen Nutzerinnen und Nutzer eine zustimmungspflichtige Änderung ab, kann die Anbieterin das Nutzungsverhältnis mit angemessener Frist beenden, wenn eine Fortführung zu den bisherigen Bedingungen nicht möglich oder nicht zumutbar ist.",
      },
      {
        heading: "§ 18 Kommunikation",
        body: "Die Anbieterin kann rechtlich erhebliche Mitteilungen per E-Mail, in der App oder über andere von den Nutzerinnen und Nutzern angegebene Kontaktwege übermitteln.\n\nNutzerinnen und Nutzer sind verpflichtet, ihre Kontaktangaben aktuell zu halten, soweit diese für Kontosicherheit, Datenschutz, Moderation oder Vertragskommunikation erforderlich sind.",
      },
      {
        heading: "§ 19 Verbraucherstreitbeilegung",
        body: "Die Anbieterin ist weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen, soweit nicht im Einzelfall etwas anderes erklärt wird.",
      },
      {
        heading: "§ 20 Schlussbestimmungen",
        body: "Es gilt deutsches Recht. Zwingende Verbraucherschutzvorschriften des Staates, in dem eine Nutzerin oder ein Nutzer den gewöhnlichen Aufenthalt hat, bleiben unberührt.\n\nIst eine Bestimmung dieser Nutzungsbedingungen unwirksam, bleiben die übrigen Bestimmungen wirksam. An die Stelle der unwirksamen Bestimmung treten die gesetzlichen Vorschriften.\n\nGerichtsstandregelungen gelten nur, soweit sie gesetzlich zulässig sind.",
      },
      {
        heading: "Anlage: Community-Regeln und Sicherheits-Hinweise",
        body: "1. Respekt und Schutz\nME SupportNet ist ein geschützter Raum für Menschen mit schwerer chronischer Erkrankung und für Personen, die unterstützen möchten. Kommunikation soll rücksichtsvoll, ruhig, nicht drängend und diskriminierungsfrei erfolgen.\n\n2. Medizinische Grenzen\nTeile Erfahrungen, aber erteile keine medizinischen Anweisungen. Schreibe nicht, dass eine Behandlung sicher hilft, dass andere ein Medikament nehmen oder absetzen sollen oder dass ärztlicher Rat entbehrlich sei.\n\n3. Datenschutz in der Community\nTeile keine Daten anderer Personen ohne Einwilligung. Dazu gehören Namen, Adressen, Diagnosen, Chatverläufe, Screenshots, Fotos, Arztbriefe und Informationen über Angehörige oder Behandelnde.\n\n4. Reale Treffen\nGib genaue Kontaktdaten erst weiter, wenn du dich sicher fühlst. Triff neue Kontakte zunächst an einem sicheren Ort oder mit einer Vertrauensperson. Beende Kontakt, wenn du dich unwohl fühlst, und nutze Blockieren oder Melden.\n\n5. Helfende\nHelfende dürfen nur Unterstützung anbieten, die sie sicher, freiwillig und rechtlich zulässig leisten können. Sie dürfen keine medizinischen, pflegerischen oder therapeutischen Leistungen anbieten, wenn ihnen hierfür die erforderliche Qualifikation oder Erlaubnis fehlt.\n\n6. Meldungen\nMelde Inhalte oder Verhalten, die dich oder andere gefährden können. Missbrauche das Meldesystem nicht. Bewahre Belege nur so lange auf, wie sie für die Meldung erforderlich sind, und teile sie nicht öffentlich.",
      },
    ],
  },
  accountDeletion: {
    title: 'Konto und Daten löschen',
    subtitle: 'ME SupportNet App — WE AID gGmbH',
    intro:
      'Hier erfährst du, wie du dein ME SupportNet Konto und alle damit verbundenen Daten löschen kannst. Es gibt zwei Wege: direkt in der App oder per E-Mail an uns. Beide führen zur vollständigen Löschung.',
    warning:
      'Die Löschung ist endgültig und kann nicht rückgängig gemacht werden. Wenn du deine Daten behalten möchtest, exportiere sie bitte vorher.',
    inApp: {
      title: 'Weg 1: In der App löschen',
      description: 'Wenn du dich noch in der App anmelden kannst, ist das der schnellste Weg:',
      steps: [
        'Öffne die ME SupportNet App und melde dich an.',
        'Gehe zu „Einstellungen".',
        'Wähle „Konto löschen".',
        'Bestätige die Sicherheitsabfrage.',
      ],
      note: 'Dein Konto und deine Daten werden sofort gelöscht — es gibt keine Wartezeit und keine Wiederherstellung.',
    },
    byEmail: {
      title: 'Weg 2: Löschung per E-Mail beantragen',
      description:
        'Wenn du keinen Zugriff mehr auf die App oder dein Konto hast, kannst du die Löschung auch schriftlich beantragen:',
      steps: [
        'Schreib eine E-Mail an support@me-support.net.',
        'Nutze als Betreff „Kontolöschung".',
        'Gib die E-Mail-Adresse an, mit der du dich in der App registriert hast.',
      ],
      note:
        'Wir bestätigen deine Identität über die angegebene E-Mail-Adresse und löschen dein Konto anschließend. Deine Anfrage wird spätestens innerhalb eines Monats bearbeitet (Art. 12 Abs. 3 DSGVO).',
      emailLabel: 'E-Mail an',
      email: 'support@me-support.net',
      emailSubject: 'Kontolöschung',
    },
    partial: {
      title: 'Einzelne Daten löschen, ohne das Konto zu löschen',
      description:
        'Du musst nicht dein ganzes Konto löschen, um Daten loszuwerden. Folgende Daten kannst du gezielt entfernen — jeweils sofort und dauerhaft:',
      items: [
        {
          label: 'Standortdaten (PLZ, Stadt, Koordinaten)',
          path: 'Einstellungen → Datenschutz → Meine Einwilligungen → Standort-Matching widerrufen',
          effect:
            'Deine Standortdaten werden sofort aus deinem Profil und aus allen deinen Hilfeanfragen und Hilfeangeboten gelöscht. Du wirst nicht mehr im Standort-Matching angezeigt.',
        },
        {
          label: 'Push-Geräte-Token',
          path: 'Einstellungen → Datenschutz → Meine Einwilligungen → Push-Benachrichtigungen widerrufen',
          effect:
            'Dein Geräte-Token wird aus unseren Systemen gelöscht und alle Benachrichtigungskategorien werden deaktiviert. Du kannst die Einwilligung jederzeit neu erteilen.',
        },
        {
          label: 'Einzelne Behandlungsansätze (Gesundheitsdaten, Art. 9 DSGVO)',
          path: 'Behandlungsansätze → Eintrag öffnen → Markierung entfernen',
          effect:
            'Der jeweilige Eintrag wird aus deinem Profil gelöscht. Dein Konto und alle anderen Daten bleiben bestehen.',
        },
        {
          label: 'Einzelne Hilfeanfragen und Hilfeangebote',
          path: 'Dein Hilfeprofil → Eintrag → Löschen',
          effect: 'Der Eintrag wird vollständig entfernt.',
        },
        {
          label: 'Profilangaben (Biografie, Pronomen, Interessen, Alter, Nutzername)',
          path: 'Profil → Profil bearbeiten',
          effect:
            'Du kannst einzelne Felder jederzeit ändern oder leeren. Geleerte Felder werden aus der Datenbank entfernt.',
        },
        {
          label: 'Blockierungen',
          path: 'Einstellungen → Blockierte Nutzer:innen',
          effect: 'Einzelne Blockierungen kannst du jederzeit wieder aufheben.',
        },
      ],
      healthNote:
        'Nicht einzeln widerrufbar: Die Einwilligung in die Verarbeitung deiner Gesundheitsdaten (Nutzertyp und Schweregrad) ist Voraussetzung für die Nutzung der App. Sie lässt sich nur durch die Löschung deines Kontos widerrufen — die App weist im Datenschutz-Dashboard ausdrücklich darauf hin.',
      byRequest:
        'Du kannst die Löschung einzelner Daten auch schriftlich anfordern: Schreib eine E-Mail an support@me-support.net mit dem Betreff „Teillöschung", der E-Mail-Adresse deines Kontos und der Angabe, welche Daten entfernt werden sollen. Wir bearbeiten die Anfrage innerhalb eines Monats (Art. 12 Abs. 3 DSGVO).',
    },
    exportFirst: {
      title: 'Vorher deine Daten sichern',
      description:
        'Du kannst deine Daten jederzeit als JSON-Datei exportieren (Art. 20 DSGVO): Einstellungen → Profil → Meine Daten herunterladen. Nach der Löschung ist das nicht mehr möglich.',
    },
    deleted: {
      title: 'Diese Daten werden gelöscht',
      description: 'Bei der Kontolöschung entfernen wir unwiderruflich:',
      items: [
        'Dein Nutzerkonto inklusive E-Mail-Adresse und Passwort',
        'Dein Profil mit Name, Nutzername, Biografie, Pronomen, Interessen, Alter und Standortangaben',
        'Dein Profilbild (Avatar)',
        'Deine Gesundheitsdaten: Nutzertyp, Schweregrad und alle eingetragenen Behandlungsansätze (Art. 9 DSGVO)',
        'Deine Hilfeanfragen und Hilfeangebote',
        'Deine Freundschaften und Freundschaftsanfragen',
        'Von dir erstellte Veranstaltungen und deine Teilnahmen an Veranstaltungen',
        'Deine Chat-Geräteschlüssel und verschlüsselten Schlüsselpakete',
        'Deine Push-Benachrichtigungs-Token — dein Gerät erhält danach keine Benachrichtigungen mehr',
        'Von dir blockierte Nutzer:innen und ausgeblendete Vorschläge',
        'Deine Bestätigungen anderer Profile',
        'Einzelchats: Sobald auch die andere Person den Chat verlassen oder ihr Konto gelöscht hat, werden Chat und Nachrichten vollständig entfernt',
      ],
    },
    retained: {
      title: 'Diese Daten bleiben — und warum',
      description:
        'Ein kleiner Teil der Daten bleibt aus rechtlichen oder technischen Gründen erhalten. Sie sind dir danach nicht mehr zuzuordnen:',
      items: [
        'Nachrichten in Gruppenchats mit verbliebenen Teilnehmenden: Der Inhalt bleibt bestehen, weil er Ende-zu-Ende-verschlüsselt an die anderen Teilnehmenden gerichtet ist und wir ihn technisch nicht entfernen können, ohne deren Chatverlauf zu zerstören. Dein Name und die Verknüpfung zu deinem Konto werden gelöscht — du erscheinst nur noch als „Gelöschter Nutzer".',
        'Meldungen, Moderationsentscheidungen und Widersprüche werden anonymisiert und ohne Bezug zu dir aufbewahrt.',
        'Einwilligungsnachweise (Zeitpunkt und Version der akzeptierten Datenschutzerklärung): 3 Jahre nach der Löschung, da wir zum Nachweis verpflichtet sind (Art. 7 DSGVO).',
        'Zugriffslogs auf Gesundheitsdaten: 24 Monate (Art. 9 DSGVO).',
        'Sicherheits-Audit-Logs: 12 Monate (Art. 32 DSGVO).',
        'Verschlüsselte Datenbank-Backups können deine Daten noch bis zur Rotation des jeweiligen Backups enthalten: tägliche Backups bis zu 14 Tage, monatliche Backups bis zu 12 Monate.',
      ],
    },
    automatic: {
      title: 'Automatische Löschung inaktiver Konten',
      description:
        'Wenn du dein Konto 12 Monate lang nicht nutzt, senden wir dir eine Vorwarnung an deine hinterlegte E-Mail-Adresse. Meldest du dich innerhalb von 30 Tagen nicht an, wird dein Konto mit allen personenbezogenen Daten automatisch und vollständig gelöscht — nach denselben Regeln wie oben beschrieben.',
    },
    contact: {
      title: 'Fragen zur Löschung',
      description:
        'Bei Fragen zur Löschung deines Kontos oder zu deinen Rechten nach der DSGVO erreichst du uns und unseren Datenschutzbeauftragten unter support@me-support.net.',
      privacyLinkText: 'Vollständige Datenschutzerklärung',
    },
  },
  cookieBanner: {
    title: 'Cookie-Einstellungen',
    description: 'Diese Website speichert nur etwas auf Ihrem Gerät, wenn Sie zustimmen: Ihre Sprach- und Design-Auswahl sowie — optional — Google Analytics zur statistischen Auswertung. Lehnen Sie ab, wird nichts gespeichert. Sie können Ihre Auswahl jederzeit ändern.',
    cookiePolicy: 'Cookie-Erklärung',
    privacyPolicy: 'Datenschutzerklärung',
    settings: 'Einstellungen',
    acceptAll: 'Alle akzeptieren',
    declineAll: 'Alle ablehnen',
  },
};
// Citations object for reference management (same as English)
export const CITATIONS_DE = {
  1: {
    title: 'Time to correct the record on the global burden of myalgic encephalomyelitis/chronic fatigue syndrome (ME/CFS)',
    authors: 'Vardaman M, Gilmour S',
    journal: 'Journal of Translational Medicine',
    year: '2025',
    url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11907965/',
    doi: '10.1186/s12967-025-06281-0'
  },
  2: {
    title: 'Economic Impact Report: Long COVID and ME/CFS',
    authors: 'ME/CFS Research Foundation',
    year: '2024',
    url: 'https://mecfs-research.org/costreport-long-covid-and-mecfs/'
  },
  3: {
    title: 'ME/CFS Funding Report',
    authors: 'ME Research UK',
    year: '2016',
    url: 'https://www.meresearch.org.uk/mecfs-funding-report/'
  },
  4: {
    title: 'Health-related quality of life in patients with chronic fatigue syndrome: an international study',
    authors: 'Nacul LC, Lacerda EM, Pheby D, et al.',
    journal: 'PLOS ONE',
    year: '2011',
    url: 'https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0132421',
    doi: '10.1371/journal.pone.0132421'
  },
  5: {
    title: 'Ärzteblatt Report: Long COVID and ME/CFS costs society 63 billion euros annually',
    authors: 'Deutsches Ärzteblatt',
    year: '2024',
    url: 'https://www.aerzteblatt.de/news/medienbericht-long-covid-und-mecfs-kosten-gesellschaft-63-milliarden-euro-jahrlich-ac6ab36c-b2e4-40a1-8f27-6b52d53dd9e8'
  },
  6: {
    title: 'BMBF Forschungsfinanzierung für ME/CFS',
    authors: 'ME/CFS Research Foundation',
    year: '2023',
    url: 'https://mecfs-research.org/en/bmbf-researchfunding-sep23/'
  },
  7: {
    title: 'Characterization of Post-exertional Malaise in Patients With Myalgic Encephalomyelitis/Chronic Fatigue Syndrome',
    authors: 'Stussman B, Williams A, Snow J, et al.',
    journal: 'Frontiers in Neurology',
    year: '2020',
    url: 'https://www.frontiersin.org/articles/10.3389/fneur.2020.01025/full',
    doi: '10.3389/fneur.2020.01025'
  },
  8: {
    title: 'Long COVID and ME/CFS: A systematic review and meta-analysis',
    authors: 'Multiple authors',
    journal: 'Journal of Infection',
    year: '2024',
    url: 'https://linkinghub.elsevier.com/retrieve/pii/S0163445324002317',
    doi: '10.1016/j.jinf.2024.01.001'
  }
};

export const CONTENT_DE = {
  app: APP_INFO_DE,
  home: HOME_CONTENT_DE,
  aboutUs: ABOUT_US_DE,
  whatIsME: WHAT_IS_ME_DE,
  mitmachen: MITMACHEN_DE,
  socialMedia: SOCIAL_MEDIA_DE,
  donationInfo: DONATION_INFO_DE,
  legal: LEGAL_CONTENT_DE,
  citations: CITATIONS_DE,
};